import { render, staticRenderFns } from "./HazardousWaste.vue?vue&type=template&id=3f36c768&"
import script from "./HazardousWaste.vue?vue&type=script&lang=js&"
export * from "./HazardousWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports